<script>
	import { ref, computed } from 'vue'
	import CartButton from '../../CartButton/CartButton.vue'
	import { useStore } from 'vuex'
	import InStockLabel from '../../InStockLabel/InStockLabel.vue'

	export default {
		name: "BasketItemSpot",
		components: {
			CartButton,
			InStockLabel
		},
		props: {
			orderLine: {
				required: true, 
				type: Object
			},
			location:{
				type: String,
				default: ''
			},
			modifyCartLayout:{
				type: Boolean,
				default: false
			}
		},
		setup(props){      
			const store = useStore()
			const orderLineData = computed(()=>props.orderLine)
			const selectedReason = ref("")
			const reasons = computed(() => store.state.ecom.customer_service_reason_codes)
			const hideWhenOnreceipt = computed(()=> props.location !== 'receipt')
			const defaultReasonCode = computed(()=>{
				const currentReasonId = orderLineData.value.reasonCode
				if(!currentReasonId) return getLabel('basketReasonDefaultOption')
				const currentReason = reasons.value.find(reason => +reason.id === +currentReasonId)
				if(!currentReason) console.error('No matching reason found for code',currentReasonId,orderLineData.value)
				return currentReason ? currentReason.displayValue : getLabel('basketReasonDefaultOption')

			})

			const isUserImpersonated = computed(() => {
				return reasons.value ? !!(reasons.value && reasons.value.length) : reasons.value
			})

			const displayReasonCodeSelection = computed(() => {
				return isUserImpersonated.value && store.getters['ecom/selectedCustomerServiceOrderType_ReasonCode_is_CreditMemo']
			})
			
			const getLabel = (labelRequested) => store.getters['labels/getLabel'](labelRequested)

			const selectReason = (orderLine) => {
				const config = {
					selectedReason : selectedReason.value.id,
					variantSku : orderLine.variantSku
				}
				store.commit('ecom/set_selected_customer_service_reason', config)
				store.dispatch('ecom/updateProductInCart', {
					productSku: orderLine.productSku,
					variantSku: orderLine.variantSku,
					quantity: orderLine.quantity
				})
			}

			return { 
				reasons,
				displayReasonCodeSelection,
				hideWhenOnreceipt,
				orderLineData,
				selectedReason,
				getLabel,
				selectReason,
				defaultReasonCode
			}
		}
	}
</script>

<template>
	
	<article class="nlx-basket-item-spot">

		<div class="nlx-basket-item-spot__wrapper">
			<div class="nlx-basket-item-spot__info-container">
				<section class="nlx-basket-item-spot__image-section" :class="{'nlx-basket-item-spot__image-section--receipt':modifyCartLayout}">
					<img :src="orderLineData.image" :alt="orderLineData.productName"/>
				</section>
				<section class="nlx-basket-item-spot__item-info-section">
					<p class="nlx-basket-item-spot__title-label">{{orderLineData.productLabel}}</p>
					<h5 class="nlx-basket-item-spot__title">{{orderLineData.productName}}</h5>
					<p class="nlx-basket-item-spot__item-no">{{getLabel('basketItemNumber')}}: {{orderLineData.variantSku}}</p>
					<p class="nlx-basket-item-spot__unit-price" v-if="hideWhenOnreceipt">{{orderLineData.unitPrice}}</p>
					<p class="nlx-basket-item-spot__price-label" v-if="hideWhenOnreceipt">{{getLabel('basketPriceVat')}}</p>
				</section>
			</div>
			<section class="nlx-basket-item-spot__pricing-section" :class="{'nlx-basket-item-spot__pricing-section--receipt':modifyCartLayout}">
				<div class="nlx-basket-item-spot__pricing-section-wrapper">
					<h4 class="nlx-basket-item-spot__total-price">{{orderLineData.total}}</h4>

					<CartButton 
						v-if="hideWhenOnreceipt"
						:productid="orderLineData.productSku" 
						:variantsku="orderLineData.variantSku" 
						:collisize="orderLineData.colliSize" 
						isParentComponentBasket="true"
						:quantity="orderLineData.quantity"
					/>

					<template v-else>
						{{getLabel('amount')}} {{orderLineData.quantity}}	
					</template>
				</div>

				<div class="nlx-basket-item-spot__pricing-section-wrapper" v-if="hideWhenOnreceipt">
					<p class="nlx-basket-item-spot__quantity">{{orderLineData.colliSizeFormatted}}</p>
					<InStockLabel 
						:inStock="orderLineData.inStock" 
						:formatted="orderLineData.inStockFormatted" 
					/>
				</div>	
			</section>
		</div>

		<div v-if="displayReasonCodeSelection" class="nlx-basket-item-spot__customer-service-reason">
			<label for="costumer-service-reason-select">{{getLabel('basketReasonDropdownTitle')}}</label>
			<select v-model="selectedReason" @change="selectReason(orderLineData)" name="costumer-service-reason" id="costumer-service-reason-select">
				<option disabled value="">{{defaultReasonCode}}</option>
				<option value="">{{getLabel('basketReasonDefaultOption')}}</option>
				<option v-for="(reason, index) in reasons" :key="index" :value="reason">{{reason.displayValue}}</option>
			</select>
		</div>
		
	</article>
	
</template>
